import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { OneClickProfileActionTypes, OneClickProfileActions } from '../actions/one-click-profile.actions';
import { OneClickProductsActions, OneClickProductsActionTypes } from './../actions/one-click-products.actions';

export interface OneClickProductsState {
  loading: boolean;
  productsAvailable: IProduct[];
  selected: IProduct[];
}

export const initialState: OneClickProductsState = {
  loading: false,
  productsAvailable: [],
  selected: [],
};

export function reducer(
  state = initialState,
  action: OneClickProductsActions | OneClickProfileActions,
): OneClickProductsState {
  switch (action.type) {
    case OneClickProductsActionTypes.LOAD_PRODUCTS: {
      return {
        ...state,
        loading: true,
      } as OneClickProductsState;
    }
    case OneClickProductsActionTypes.LOAD_PRODUCTS_COMPLETE: {
      return {
        ...state,
        loading: false,
        productsAvailable: action.payload,
      } as OneClickProductsState;
    }
    case OneClickProductsActionTypes.SELECT_PRODUCT: {
      state.selected[action.index] = undefined;
      return {
        ...state,
        selected: state.selected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickProductsState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickProductsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
